import { AutoCompleteComponent } from "@syncfusion/ej2-react-dropdowns";
import { CheckBoxComponent } from "@syncfusion/ej2-react-buttons";
import React, { Component } from "react";
import { enableRtl } from "@syncfusion/ej2-base";
import { Button, Spinner } from "react-bootstrap";
// import DatePicker from 'react-datepicker2';
import moment from "moment-jalaali";
import { Query } from "@syncfusion/ej2-data";
import NumberFormat from "react-number-format";
import dateicon from "../assets/dateicon.png";
import { AsyncTypeahead } from "react-bootstrap-typeahead";
import { toast } from "react-toastify";

import DatePicker, { DateObject } from "react-multi-date-picker";
// import Toolbar from "react-multi-date-picker/plugins/toolbar"
import "react-multi-date-picker/styles/layouts/mobile.css";
import "react-multi-date-picker/styles/layouts/prime.css";
import "react-multi-date-picker/styles/colors/bluee.css";

enableRtl(true);

export default class Transfer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      chashchange: "",
      quantitychange: "",
      selectedSymbol: null,
      selectedSymbol1: null,
      selectedBasket: "",
      selectedBasket1: "",
      dateValue: moment().format("jYYYY/jMM/jDD"),
      Redirect: false,
      dateErrorText: "",
      symbolErrorText: "",
      quantityErrorText: "",
      cashErrorText: "",
      basketErrorText: "",
      basket1ErrorText: "",
      dateFalse: false,
      symbolFalse: false,
      quantityFalse: false,
      cashFalse: false,
      basketFalse: false,
      basket1False: false,
      maxDateStart: moment().add(0, "days").format("jYYYY/jMM/jDD"),
      options: [],
      isLoading: false,
      currenttseid: "",
      buttonDisabled: false,
      brokercheck: true,
      costchange: "",
      isEdit: null,
      lowestprice: null,
      highestprice: null,
      hasCost: false,
    };

    this.fields = { value: "full_name" };
    this.fields1 = { value: "lable" };
    this.fields2 = { value: "full_name" };
    this.query = new Query().where("type_code", "notequal", 7);

    this.cashchange = this.cashchange.bind(this);
    this.quantitychange = this.quantitychange.bind(this);
    this.resetForm = this.resetForm.bind(this);
    this.calculateCost = this.calculateCost.bind(this);
    this.getSymbol = this.getSymbol.bind(this);
    this.getPriceInterval = this.getPriceInterval.bind(this);

    this.datepickerr = React.createRef();
  }

  searchSymbol(query) {
    this.setState({ isLoading: true });
    let data = {
      mobile: localStorage.getItem("mobile"),
      token: localStorage.getItem("token"),
      word: query,
      type: "all",
    };
    fetch("/api/searchSymbol", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((resultt) => {
        if (resultt.status === 200) {
          this.setState({ options: resultt.result, isLoading: false });
        } else {
          this.props.history.push("/Login");
        }
      });
  }

  getSymbol(query, id) {
    this.setState({ isLoading: true });
    let data = {
      mobile: localStorage.getItem("mobile"),
      token: localStorage.getItem("token"),
      word: query,
      type: "all",
    };

    fetch("/api/searchSymbol", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((resultt) => {
        if (resultt.status === 200) {
          this.setState({ options: resultt.result }, () => {
            resultt.result.forEach((element) => {
              if (element.id === id) {
                let s = [];
                s.push(element);
                this.setState(
                  { selectedSymbol: element, selectedSymbol1: s },
                  () => {
                    this.getPriceInterval(this.state.selectedSymbol);
                  }
                );
              }
            });
            this.setState({ isLoading: false });
          });
        } else {
          this.props.history.push("/Login");
        }
      });
  }

  SubmitFrom() {
    try {
      let selectbasket = this.state.selectedBasket;
      let selectbasket1 = this.state.selectedBasket1;

      let selectbroker;
      if (this.state.brokercheck) selectbroker = this.acBrokers.value;

      // let date=this.convertDate(this.state.dateValue);
      let date = moment(this.state.dateValue, "jYYYY/jMM/jDD").format(
        "jYYYY-jMM-jDD"
      );

      let symbolid;
      if (this.state.selectedSymbol !== null)
        symbolid = this.state.selectedSymbol.id;
      let brokerid;
      let basketid;
      let basketid1;

      this.props.userBasketsData.forEach(function (entry) {
        if (entry.lable === selectbasket) {
          basketid = entry.id;
        }

        if (entry.lable === selectbasket1) {
          basketid1 = entry.id;
        }
      });

      if (this.state.brokercheck) {
        this.props.userBrokersData.forEach(function (entry) {
          if (entry.full_name === selectbroker) {
            brokerid = entry.id;
          }
        });
      }

      if (this.state.dateValue === "") {
        this.setState({ dateFalse: true, dateErrorText: "تاریخ نامعتبر است" });
        return;
      } else {
        this.setState({ dateFalse: false, dateErrorText: "" });
      }
      if (
        this.acBaskets.value === null ||
        this.acBaskets.value === "" ||
        basketid === undefined
      ) {
        this.setState({
          basketFalse: true,
          basketErrorText: "نام سبد نامعتبر است",
        });
        return;
      } else {
        this.setState({ basketFalse: false, basketErrorText: "" });
      }
      if (
        this.acBaskets1.value === null ||
        this.acBaskets1.value === "" ||
        basketid1 === undefined
      ) {
        this.setState({
          basket1False: true,
          basket1ErrorText: "نام سبد نامعتبر است",
        });
        return;
      } else {
        this.setState({ basket1False: false, basket1ErrorText: "" });
      }
      if (selectbasket === selectbasket1) {
        this.setState({
          basket1False: true,
          basket1ErrorText: "نام سبد مبدا و مقصد باید متفاوت باشد",
        });
        return;
      } else {
        this.setState({ basket1False: false, basket1ErrorText: "" });
      }
      if (this.state.brokercheck) {
        if (
          this.acBrokers.value === null ||
          this.acBrokers.value === "" ||
          brokerid === undefined
        ) {
          this.setState({
            brokerFalse: true,
            brokerErrorText: "نام کارگزاری نامعتبر است",
          });
          return;
        } else {
          this.setState({ brokerFalse: false, brokerErrorText: "" });
        }
      }

      let cash = this.state.chashchange
        .toString()
        .replace(/,/g, "")
        .replace(/ /g, "")
        .replace(/ریال/g, "");
      let quantity = this.state.quantitychange
        .toString()
        .replace(/,/g, "")
        .replace(/ /g, "")
        .replace(/ریال/g, "");

      let indexofelement = 4;
      if (this.props.isPopup) indexofelement = 0;
      if (this.state.selectedSymbol === null) {
        document.querySelectorAll(".rbt-input-main")[
          indexofelement
        ].style.border = "1px solid var(--red1)";
        this.setState({
          symbolFalse: true,
          symbolErrorText: "نام نماد باید وارد شود",
        });
        return;
      } else {
        document.querySelectorAll(".rbt-input-main")[
          indexofelement
        ].style.border = "1px solid #ced4da";
        this.setState({ symbolFalse: false, symbolErrorText: "" });
      }
      if (quantity === "") {
        this.setState({
          quantityFalse: true,
          quantityErrorText: "تعداد نامعتبر است",
        });
        return;
      } else if (Number(quantity) < 1) {
        this.setState({
          quantityFalse: true,
          quantityErrorText: "تعداد نمی تواند صفر باشد",
        });
        return;
      } else {
        this.setState({ quantityFalse: false, quantityErrorText: "" });
      }

      if (cash === "") {
        this.setState({ cashFalse: true, cashErrorText: "مبلغ نامعتبر است" });
        return;
      } else if (Number(cash) < 1) {
        this.setState({
          cashFalse: true,
          cashErrorText: "مبلغ نمی تواند صفر باشد",
        });
        return;
      } else {
        this.setState({ cashFalse: false, cashErrorText: "" });
      }

      let sourcetr = false;
      let destinationtr = false;

      if (this.check1.checked) {
        destinationtr = true;
      }

      if (this.check2.checked) {
        sourcetr = true;
      }

      let data = {
        mobile: localStorage.getItem("mobile"),
        token: localStorage.getItem("token"),
        type: "transferSymbol",
        date: date,
        cash_change: cash,
        broker_id: brokerid,
        source_id: basketid,
        destination_id: basketid1,
        quantity_change: quantity,
        source_tr: sourcetr,
        destination_tr: destinationtr,
        symbol_id: symbolid,
        symbol_type: this.state.selectedSymbol.type_code,
      };

      if (this.state.isEdit) {
        this.editAction(data, brokerid, basketid);
        return;
      }

      this.setState({ buttonDisabled: true });
      fetch("/api/transaction", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      })
        .then((res) => res.json())
        .then((resultt) => {
          if (resultt.status === 200) {
            this.props.onRefresh();
            this.resetForm();
            toast.success("سند مورد نظر با موفقیت ثبت گردید", {
              position: toast.POSITION.BOTTOM_LEFT,
              hideProgressBar: true,
              autoClose: 8000,
              toastClassName: "toast",
            });
          } else if (resultt.status === 401) {
            this.setState({ Redirect: true });
          } else {
            toast.error(resultt.message, {
              position: toast.POSITION.BOTTOM_LEFT,
              hideProgressBar: true,
              autoClose: 8000,
              toastClassName: "toast",
            });
          }
          this.setState({ buttonDisabled: false });
        });
    } catch (error) {
      this.setState({ buttonDisabled: false });
    }
  }

  convertDate(date) {
    let timee = new Intl.DateTimeFormat("en-US", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    }).formatToParts(date);
    let year = "";
    let month = "";
    let day = "";
    timee.forEach((element) => {
      if (element.type === "year") {
        year = element.value;
      } else if (element.type === "month") {
        month = element.value;
      } else if (element.type === "day") {
        day = element.value;
      }
    });
    let formatedDate = year + "/" + month + "/" + day;
    let pdate = moment(formatedDate, "YYYY/MM/DD").format("jYYYY-jMM-jDD");
    return pdate;
  }

  componentDidMount() {
    if (
      this.props.selectedBrokerId === 0 &&
      this.props.userBrokersData.length < 2
    ) {
      this.setBrokerValue(this.props.userBrokersData[0].full_name, true);
    }

    // if (this.props.userBasketsData.length<2){
    //     this.setBasketValue(this.props.userBasketsData[0].lable,true)
    // }
  }

  // dateChange(dateValue){
  //     // this.setState({ dateValue: dateValue})
  //     if (dateValue===this.state.dateValue) return
  //     this.setState({dateValue: dateValue},
  //     ()=>{
  //         if (this.state.selectedSymbol!==null && this.state.dateValue!==''){
  //             this.getPriceInterval(this.state.selectedSymbol);
  //         }
  //     });
  // }

  fixNumber(str) {
    var persianNumbers = [
        /۰/g,
        /۱/g,
        /۲/g,
        /۳/g,
        /۴/g,
        /۵/g,
        /۶/g,
        /۷/g,
        /۸/g,
        /۹/g,
      ],
      arabicNumbers = [
        /٠/g,
        /١/g,
        /٢/g,
        /٣/g,
        /٤/g,
        /٥/g,
        /٦/g,
        /٧/g,
        /٨/g,
        /٩/g,
      ];
    if (typeof str === "string") {
      for (var i = 0; i < 10; i++) {
        str = str.replace(persianNumbers[i], i).replace(arabicNumbers[i], i);
      }
    }
    return str;
  }

  dateChange(dateValue) {
    let value = this.fixNumber(new DateObject(dateValue).format("YYYY/MM/DD"));

    if (value === this.state.dateValue) return;

    // this.setState({ dateValue: value})
    this.setState({ dateValue: value }, () => {
      if (this.state.selectedSymbol !== null && this.state.dateValue !== "") {
        this.getPriceInterval(this.state.selectedSymbol);
      }
    });
  }

  getPriceInterval(value) {
    try {
      let date = this.convertDate(this.state.dateValue);

      let data = {
        mobile: localStorage.getItem("mobile"),
        token: localStorage.getItem("token"),
        date: date,
        symbol_id: value.id,
      };

      fetch("/api/priceInterval", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      })
        .then((res) => res.json())
        .then((resultt) => {
          if (resultt.status === 200) {
            if (resultt.result[0].low !== null) {
              this.setState({
                lowestprice: resultt.result[0].low,
                highestprice: resultt.result[0].high,
                hasCost: true,
              });
            } else {
              this.setState({
                lowestprice: 0,
                highestprice: 0,
                hasCost: false,
              });
            }
          } else if (resultt.status === 401) {
            this.setState({ Redirect: true });
          }
        })
        .catch((err) => {});
    } catch (error) {}
  }

  acSymbolChange(item) {
    try {
      if (item.length < 1) {
        this.setState({ selectedSymbol: null, selectedSymbol1: null });
        return;
      }
      // console.log(item);
      let s = [];
      s.push(item[0]);
      this.setState({ selectedSymbol: item[0], selectedSymbol1: s }, () => {
        this.getPriceInterval(this.state.selectedSymbol);
      });
    } catch (error) {}
  }

  acBasketChange() {
    this.setState({ selectedBasket: this.acBaskets.value });
  }

  acBasketChange1() {
    this.setState({ selectedBasket1: this.acBaskets1.value });
  }

  // cashchange(event){
  //     this.setState({chashchange: event.target.value});
  // }

  // quantitychange(event){
  //     this.setState({quantitychange: event.target.value});
  // }

  cashchange(event) {
    this.setState({ chashchange: event.target.value });

    this.calculateCost(event.target.value, this.state.quantitychange);
  }

  // costchange(event){
  //     this.setState({costchange: event.target.value});
  // }

  quantitychange(event) {
    this.setState({ quantitychange: event.target.value });
    this.calculateCost(this.state.chashchange, event.target.value);
  }

  setBrokerValue(name, readonly) {
    if (this.state.brokercheck) {
      this.acBrokers.value = name;
      this.acBrokers.readonly = readonly;
    }
  }

  check1Change() {
    if (this.check1.checked) {
      this.check2.disabled = false;
      this.setState({ brokercheck: true });
    } else {
      this.check2.disabled = true;
      this.check2.checked = false;
      this.setState({ brokercheck: false });
    }
  }
  check2Change() {}

  calculateCost(cash, quantity) {
    try {
      cash = cash
        .toString()
        .replace(/,/g, "")
        .replace(/ /g, "")
        .replace(/ریال/g, "")
        .trim();

      quantity = quantity
        .toString()
        .replace(/,/g, "")
        .replace(/ /g, "")
        .replace(/ریال/g, "")
        .trim();
      if (
        quantity !== null &&
        cash !== null &&
        quantity !== "" &&
        cash !== "" &&
        quantity > 0 &&
        cash > 0
      ) {
        let aa = Math.floor(cash / quantity);
        this.setState({ costchange: aa });
      } else {
        this.setState({ costchange: "" });
      }
    } catch (error) {
      this.setState({ costchange: "" });
    }
  }

  itemTemplate(data) {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          width: "100%",
          justifyContent: "space-between",
        }}
      >
        <div>{data.broker_name}</div>
        {data.lable !== null &&
          data.lable !== "" &&
          data.lable !== undefined && (
            <div style={{ fontSize: "12px", color: "var(--gray1)" }}>
              {data.lable}
            </div>
          )}
      </div>
    );
  }

  cancelForm() {
    if (this.props.isPopup) {
      this.props.cancelForm();
      return;
    } else {
      this.resetForm();
    }
  }

  resetForm() {
    // if (this.props.isPopup){
    //     this.props.cancelForm();
    //     return;
    // }
    this.setState({
      hasCost: false,
      lowestprice: null,
      highestprice: null,
      chashchange: "",
      quantitychange: "",
      selectedSymbol: null,
      selectedSymbol1: null,
      selectedBasket: "",
      selectedBasket1: "",
      costchange: "",
      isEdit: null,
      symbolErrorText: "",
      quantityErrorText: "",
      cashErrorText: "",
      brokerErrorText: "",
      basket1ErrorText: "",
      basketErrorText: "",
      dateErrorText: "",
    });
    this.acSymbol.clear();
    this.acBaskets.value = "";
    this.acBaskets1.value = "";
    if (
      this.state.brokercheck &&
      this.props.selectedBrokerId === 0 &&
      this.props.userBrokersData.length > 1
    ) {
      this.acBrokers.value = "";
    }
    document.querySelectorAll(".rbt-input-main")[4].style.border =
      "1px solid #ced4da";
  }

  editFrom(data) {
    this.setState(
      {
        chashchange: Math.abs(data.cash_change),
        quantitychange: Math.abs(data.quantity),
        dateValue: moment(data.date, "jYYYY-jMM-jDD").format("jYYYY/jMM/jDD"),
      },
      () => {
        this.calculateCost(this.state.chashchange, this.state.quantitychange);
      }
    );

    // if (this.props.userBasketsData.length>1){
    //     this.acBaskets.value=data.basket1;
    //     this.acBaskets1.value=data.basket2;
    // }
    this.check1.checked = false;
    this.check2.checked = false;
    data.child.forEach((element) => {
      if (element.type_id === 1) {
        this.check1.checked = true;
      } else if (element.type_id === 2) {
        this.check2.checked = true;
      } else {
        if (element.quantity < 0) {
          this.acBaskets.value = element.basket;
        } else if (element.quantity > 0) {
          this.acBaskets1.value = element.basket;
        }
      }
    });

    if (this.check1.checked) {
      this.check2.disabled = false;
      this.setState({ brokercheck: true });
    } else {
      this.check2.disabled = true;
      this.check2.checked = false;
      this.setState({ brokercheck: false });
    }

    if (data.broker_id !== null) {
      this.setState({ brokercheck: true }, () => {
        if (this.props.userBrokersData.length > 1) {
          if (data.lable !== null && data.lable !== "") {
            this.acBrokers.value = data.broker + " (" + data.lable + ")";
          } else {
            this.acBrokers.value = data.broker;
          }
        }
      });
    } else {
      this.setState({ brokercheck: false });
    }

    // alert(data.symbol)
    // alert(data.symbol_id)
    this.getSymbol(data.symbol, data.symbol_id);
    this.setState({ isEdit: data });

    // let symbol=[];
    // symbol.push(data.symbol)
    // this.setState({selectedSymbol:symbol})
  }

  editAction(body, brokerid, basketid) {
    let data = body;

    let d = [];
    if (this.state.isEdit.child === undefined) {
      d.push(this.state.isEdit);
    } else {
      this.state.isEdit.child.forEach((element) => {
        d.push(element);
      });
    }
    data.list = d;

    this.setState({ buttonDisabled: true });
    fetch("/api/editTransaction", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((resultt) => {
        if (resultt.status === 200) {
          this.props.onRefresh();

          this.resetForm();
          toast.success("سند با موفقیت ویرایش شد", {
            position: toast.POSITION.BOTTOM_LEFT,
            hideProgressBar: true,
            autoClose: 8000,
            toastClassName: "toast",
          });
        } else if (resultt.status === 401) {
          this.setState({ Redirect: true });
        } else {
          toast.error(resultt.message, {
            position: toast.POSITION.BOTTOM_LEFT,
            hideProgressBar: true,
            autoClose: 8000,
            toastClassName: "toast",
          });
        }
        this.setState({ buttonDisabled: false });
      })
      .catch((err) => {
        this.setState({ buttonDisabled: false });
      });
  }

  render() {
    return (
      <div className="contentStyle">
        <div id="componentsParent">
          {/* <div style={{width:'100%'}}>
                        <DatePicker
                            className={this.state.dateFalse ? "form-control inputStyleRedDate":"form-control inputStyleFormDate"}
                            timePicker={false}
                            isGregorian={false}
                            ref={(scope) => this.datepickerr = scope}
                            onChange={valuee => this.dateChange(valuee)}
                            value={this.state.dateValue}
                            max={this.state.maxDateStart}
                        />
                    </div> */}
          <div className="InputWithIcon" style={{ direction: "ltr" }}>
            <div className="inputImageDiv">
              <img src={dateicon} className="inputImage" alt="date" />
            </div>
            {/* <DatePicker
                            className={this.state.dateFalse ? "form-control inputStyleRed":"form-control inputStyleForm"}
                            timePicker={false}
                            isGregorian={false}
                            ref={(scope) => this.datepickerr = scope}
                            onChange={valuee => this.dateChange(valuee)}
                            value={this.state.dateValue}
                            max={this.state.maxDateStart}
                        /> */}
            <DatePicker
              ref={this.datepickerr}
              value={this.state.dateValue}
              inputClass={
                this.state.dateFalse
                  ? "form-control inputStyleRed"
                  : "form-control inputStyleForm"
              }
              calendar="persian"
              locale="fa"
              weekDays={["ش", "ی", "د", "س", "چ", "پ", "ج"]}
              format="YYYY/MM/DD"
              animation
              className={this.props.isPopup ? "rmdp-mobile bluee" : "bluee"}
              onChange={(valuee) => this.dateChange(valuee)}
              maxDate={this.state.maxDateStart}
              editable={false}
              inputMode="none"
              fixMainPosition={true}
              fixRelativePosition={true}
              placeholder="تاریخ"
            />
          </div>
          <div className="errorMessage1">{this.state.dateErrorText}</div>

          <AutoCompleteComponent
            showPopupButton={true}
            className={
              this.state.basketFalse ? "inputStyleRed" : "inputStyleForm"
            }
            allowCustom={false}
            change={this.acBasketChange.bind(this)}
            ref={(scope) => (this.acBaskets = scope)}
            filterType="Contains"
            enableRtl="true"
            noRecordsTemplate="موردی یافت نشد"
            popupHeight="550px"
            dataSource={this.props.userBasketsData}
            fields={this.fields1}
            placeholder="سبد مبدأ"
            autofill={true}
          />
          <div className="errorMessage1">{this.state.basketErrorText}</div>
          <AutoCompleteComponent
            showPopupButton={true}
            className={
              this.state.basket1False ? "inputStyleRed" : "inputStyleForm"
            }
            allowCustom={false}
            change={this.acBasketChange1.bind(this)}
            ref={(scope) => (this.acBaskets1 = scope)}
            filterType="Contains"
            enableRtl="true"
            noRecordsTemplate="موردی یافت نشد"
            popupHeight="550px"
            dataSource={this.props.userBasketsData}
            fields={this.fields1}
            placeholder="سبد مقصد"
            autofill={true}
          />
          <div className="errorMessage1">{this.state.basket1ErrorText}</div>

          <AsyncTypeahead
            id="symbolAuto"
            searchText="در حال جستجو..."
            promptText="لطفاً نام نماد مورد نظر را تایپ کنید"
            paginationText="نمایش موارد بیشتر ..."
            useCache={true}
            ref={(scope) => (this.acSymbol = scope)}
            isLoading={this.state.isLoading}
            labelKey="full_name"
            minLength={2}
            onSearch={this.searchSymbol.bind(this)}
            onInputChange={(text) => {
              if (text === "")
                this.setState({
                  selectedSymbol: null,
                  selectedSymbol1: null,
                  lowestprice: null,
                  highestprice: null,
                });
            }}
            options={this.state.options}
            placeholder="نماد"
            delay={100}
            emptyLabel="موردی یافت نشد"
            flip={true}
            clearButton={true}
            onChange={this.acSymbolChange.bind(this)}
            selected={this.state.selectedSymbol1}
          />
          <div className="errorMessage1">{this.state.symbolErrorText}</div>

          <NumberFormat
            placeholder="تعداد"
            className={
              this.state.quantityFalse
                ? "form-control inputStyleRed"
                : "form-control inputStyleForm"
            }
            displayType={"input"}
            thousandSeparator={true}
            onChange={this.quantitychange}
            value={this.state.quantitychange}
          />
          <div className="errorMessage1">{this.state.quantityErrorText}</div>

          <NumberFormat
            placeholder="مبلغ کل معامله"
            className={
              this.state.cashFalse
                ? "form-control inputStyleRed"
                : "form-control inputStyleForm"
            }
            displayType={"input"}
            thousandSeparator={true}
            suffix={" ریال"}
            onChange={this.cashchange}
            value={this.state.chashchange}
          />
          <div className="errorMessage1">{this.state.cashErrorText}</div>

          {this.state.costchange !== "" && (
            <div
              style={{
                width: "100%",
                color: "var(--gray1)",
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                fontSize: "10px",
                direction: "rtl",
                marginBottom: "15px",
                backgroundColor: "white",
                borderRadius: "5px",
                height: "30px",
                border: "1px solid var(--gray2)",
                alignItems: "center",
                padding: "0px 10px",
                paddingTop: "2px",
              }}
            >
              <div>بهای تمام شده:</div>{" "}
              <NumberFormat
                value={this.state.costchange}
                displayType={"text"}
                thousandSeparator={true}
                suffix={" ریال"}
              />
            </div>
          )}

          {this.state.hasCost && this.state.lowestprice !== null && (
            <div
              style={{
                width: "100%",
                display: "flex",
                flexDirection: "row-reverse",
                justifyContent: "space-between",
                fontSize: "10px",
                direction: "rtl",
                marginBottom: "15px",
              }}
            >
              <div
                style={{
                  color: "var(--danger)",
                  display: "flex",
                  flexDirection: "row",
                  backgroundColor: "white",
                  borderRadius: "5px",
                  width: "49%",
                  height: "30px",
                  border: "1px solid var(--gray2)",
                  justifyContent: "space-between",
                  alignItems: "center",
                  padding: "0px 10px",
                  paddingTop: "2px",
                }}
              >
                <div>کمترین: </div>
                <NumberFormat
                  value={this.state.lowestprice}
                  displayType={"text"}
                  thousandSeparator={true}
                  suffix={" ریال"}
                />
              </div>
              <div
                style={{
                  color: "var(--green1)",
                  display: "flex",
                  flexDirection: "row",
                  backgroundColor: "white",
                  borderRadius: "5px",
                  width: "49%",
                  height: "30px",
                  border: "1px solid var(--gray2)",
                  justifyContent: "space-between",
                  alignItems: "center",
                  padding: "0px 10px",
                  paddingTop: "2px",
                }}
              >
                <div>بیشترین:</div>{" "}
                <NumberFormat
                  value={this.state.highestprice}
                  displayType={"text"}
                  thousandSeparator={true}
                  suffix={" ریال"}
                />
              </div>
            </div>
          )}
          {!this.state.hasCost && this.state.lowestprice !== null && (
            <div
              style={{
                color: "var(--danger)",
                width: "100%",
                display: "flex",
                flexDirection: "row-reverse",
                justifyContent: "flex-end",
                fontSize: "10px",
                direction: "rtl",
                marginBottom: "15px",
                borderRadius: "5px",
                height: "30px",
                border: "1px solid var(--gray2)",
                alignItems: "center",
                padding: "0px 10px",
              }}
            >
              <div>در تاریخ تعیین شده معامله برای نماد مورد نظر انجام نشده</div>
            </div>
          )}

          <div
            style={{
              display: "flex",
              flexDirection: "row",
              width: "100%",
              justifyContent: "space-between",
              flexWrap: "wrap",
            }}
          >
            <CheckBoxComponent
              className="checkBoxContainer"
              label="ثبت واریز برای سبد مقصد"
              checked
              ref={(scope) => (this.check1 = scope)}
              change={this.check1Change.bind(this)}
              enableRtl="true"
            />
            <CheckBoxComponent
              className="checkBoxContainer"
              label="ثبت برداشت برای سبد مبدأ"
              checked
              ref={(scope) => (this.check2 = scope)}
              change={this.check2Change.bind(this)}
              enableRtl="true"
            />
            {/* <RadioButtonComponent label="ثبت واریز برای سبد مقصد" ref={(scope) => this.radioBroker = scope} change={this.radioBrokerChange.bind(this)} enableRtl='true' name="type" checked={true} />
                        <RadioButtonComponent label="ثبت برداشت برای سبد مبدأ" ref={(scope) => this.radioAccount = scope} enableRtl='true' name="type" change={this.radioAccountChange.bind(this)} /> */}
          </div>

          {this.state.brokercheck && (
            <AutoCompleteComponent
              itemTemplate={this.itemTemplate}
              showPopupButton={true}
              className={
                this.state.brokerFalse ? "inputStyleRed" : "inputStyleForm"
              }
              ref={(scope) => (this.acBrokers = scope)}
              filterType="Contains"
              enableRtl="true"
              noRecordsTemplate="موردی یافت نشد"
              popupHeight="850px"
              dataSource={this.props.userBrokersData}
              fields={this.fields2}
              placeholder="کارگزاری"
              autofill={true}
            />
          )}
          {this.state.brokercheck && (
            <div className="errorMessage1">{this.state.brokerErrorText}</div>
          )}
          {/* <Button variant="secondary" style={{width:'50%',fontSize:'13px',marginTop:'20px',height:'30px'}} onClick={this.SubmitFrom.bind(this)}>ثبت</Button> */}
          {!this.state.isEdit && !this.props.isPopup && (
            <Button
              variant="secondary"
              className="formButtonStyle"
              disabled={this.state.buttonDisabled}
              onClick={this.SubmitFrom.bind(this)}
            >
              {this.state.buttonDisabled && (
                <Spinner className="spinnerStyle" animation="border" />
              )}
              {!this.state.buttonDisabled && <div>انتقال</div>}
            </Button>
          )}
          {(this.state.isEdit || this.props.isPopup) && (
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                marginTop: "20px",
                justifyContent: "space-between",
                width: "100%",
              }}
            >
              <Button
                variant="danger"
                onClick={this.cancelForm.bind(this)}
                style={{ minWidth: "45%", fontSize: "13px", height: "30px" }}
              >
                انصراف
              </Button>
              <div style={{ width: "10px" }} />
              <Button
                variant={this.state.isEdit ? "primary" : "secondary"}
                style={{ minWidth: "45%", fontSize: "13px", height: "30px" }}
                disabled={this.state.buttonDisabled}
                onClick={this.SubmitFrom.bind(this)}
              >
                {this.state.buttonDisabled && (
                  <Spinner className="spinnerStyle" animation="border" />
                )}
                {!this.state.buttonDisabled && this.state.isEdit && (
                  <div>ویرایش</div>
                )}
                {!this.state.buttonDisabled && !this.state.isEdit && (
                  <div>ثبت&nbsp;{this.state.buttonTitle}</div>
                )}
              </Button>
            </div>
          )}
        </div>
      </div>
    );
  }
}
